import * as THREE from "three";

export default class OutlineType {
    static HIGHLIGHT = new OutlineType("highlight", {
        edgeStrength: 5.0,
        edgeThickness: 0.1,
        edgeGlow: 0.0,
        color: new THREE.Color(0xffffff),
    });
    static ATTEMPTED_ROUTE = new OutlineType("attempted_route", {
        edgeStrength: 10.0,
        edgeThickness: 1.0,
        edgeGlow: 0.5,
        // color: new THREE.Color(0x2f9612),
        // color: new THREE.Color(0x187338),
        // color: new THREE.Color(0x127334),
        color: new THREE.Color(0x066327),
    });
    static CLIMBED_ROUTE = new OutlineType("climbed_route", {
        edgeStrength: 10.0,
        edgeThickness: 1.0,
        edgeGlow: 0.5,
        // color: new THREE.Color(0xe01d1d),
        // color: new THREE.Color(0xbd3131),
        color: new THREE.Color(0xbd1e1e),
    });
    static WALL_BORDER = new OutlineType("wall_border", {
        edgeStrength: 5.0,
        edgeThickness: 0.5,
        edgeGlow: 0.0,
        color: new THREE.Color(0xe0f0ef),
        blending: THREE.SubtractiveBlending,
    });

    constructor(typeId, params) {
        this.typeId = typeId;
        this.params = params;
    }
}
